<template>
    <div id="resource-item">
      <div>
        <van-row justify="space-between" style="width: 98%;margin: 0 auto">
          <van-col :span="12" v-for="(item,index) in resourceInfo" :key="index" style="margin-top: 20px">
            <div class="resource-content"  @click="jumpTo(item.id)">
              <img class="resource-cover" :src="item.cover" />
              <div class="resource-title">{{item.title}}</div>
              <div class="resource-price" v-if="item.free">免费</div>
              <div class="resource-price" v-else>¥{{item.price}}元</div>
            </div>
          </van-col>
        </van-row>
      </div>
    </div>
</template>

<script>
export default {
  name: 'ResourceItem',
  props: ['resourceInfo'],
  data () {
    return {
      // msg: '+++++'
    };
  },
  methods: {
    jumpTo (id) {
      this.$router.push({ name: 'BookDetail', query: { id } });
    }
  }
};
</script>

<style scoped>
.resource-content{
  width: 88%;
  margin: 0 auto;
}
.resource-cover{
  border-radius: 10px;
  box-shadow: 3px 3px 5px #CCCCCC;
  width: 100%;
  height: auto;
}
.resource-title{
  overflow: hidden;
  white-space: nowrap;
  text-overflow:ellipsis;
  font-size: .38rem;
  font-weight: bolder;
  text-align: left;
  line-height: 1.2rem;
}
.resource-price{
  color: #FF0000;
  font-size: 30px;
  font-weight: bolder;
  text-align: left;
}
</style>